import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { Lead, RefreshEmail } from 'Pages/partnerProfile'
import { ShortDataModel } from 'Models'
import { serialize } from 'object-to-formdata'

export const leadApi = {
	createLead: async (data: Lead) => {
		const res = await axiosDS().post<Lead>(urls.partnerProfile.lead.index, {
			data,
		})
		return res.data
	},
	activateLead: async (token: string, data: Lead) => {
		const res = await axiosDS().post<Lead>(`${urls.partnerProfile.lead.activate}/${token}`, {
			data,
		})
		return res.data
	},
	validateLead: async (token: string, data: Lead) => {
		const res = await axiosDS().post<Lead>(`${urls.partnerProfile.lead.validate}/${token}`, {
			data,
		})
		return res.data
	},
	completeLead: async (token: string, data: Lead) => {
		const res = await axiosDS().post<Lead>(
			`${urls.partnerProfile.lead.complete}/${token}`,
			serialize({ data }, { allowEmptyArrays: false })
		)
		return res.data
	},
	getTokenLead: async (token: string) => {
		const res = await axiosDS().get<Lead>(`${urls.partnerProfile.lead.index}/${token}/parent`)
		return res.data
	},
	getDictIncorporationForm: async () => {
		const res = await axiosDS().get<ShortDataModel[]>(urls.partnerProfile.lead.incorporation_form)
		return res.data
	},
	refreshSmsLead: async (id: string | number) => {
		const res = await axiosDS().post<string>(`${urls.partnerProfile.lead.refresh_sms}/${id}`)
		return res.data
	},
	refreshEmailLead: async (data: RefreshEmail) => {
		const res = await axiosDS().post<RefreshEmail>(urls.partnerProfile.lead.refresh_email, {
			data,
		})
		return res.data
	},
	recreateEmailLead: async (data: RefreshEmail) => {
		const res = await axiosDS().post<RefreshEmail>(urls.partnerProfile.lead.recreate_email, {
			data,
		})
		return res.data
	},
}
